export default "https://cdn-static.gokick.com/assets/4beacdc4d8fafa1e61a7f98396d8ad8b9ab7b90c/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";